<script setup lang="ts">
import { Feature } from 'ol'
import Point from 'ol/geom/Point'
import Geometry from 'ol/geom/Geometry'

import { transform } from 'ol/proj'
import BaseLayerPoints from '@/components/map/base-layers/BaseLayerPoints.vue'
import { MatchmakingItem, MatchmakingPost } from '~/types/types'
import { useMatchmakingDataStore } from '~/stores/matchmaking'

const matchmakingStore = useMatchmakingDataStore()
matchmakingStore.initData()

const locations = computed(() => matchmakingStore.locationsWithFilters)
const features = ref<Feature<Geometry>[]>([])

onMounted(() => {
  if (locations.value.length === 0) return
  features.value = parseFeatures(locations.value)
})

watch(locations, () => {
  features.value = parseFeatures(locations.value)
})

// const minSize = 12
// const maxSize = 48

const symbolOverrides = {
  // offset: [
  //   'array',
  //   0,
  //   ['interpolate', ['exponential', 2.5], ['zoom'], 2, minSize / 2, 14, maxSize / 2],
  // ],
  // size: ['interpolate', ['exponential', 2.5], ['zoom'], 2, minSize, 14, maxSize],
}
function transformCoordinates(coordinates: number[]) {
  return transform(
    coordinates.map((c) => c),
    'EPSG:4326',
    'EPSG:3857'
  )
}

function parseFeatures(locations: MatchmakingItem[]) {
  return locations.map((location) => {
    const transformedCoords = transformCoordinates([location.lng, location.lat])
    const feature = new Feature({
      geometry: new Point(transformedCoords),
      name: location?.operator_name,
      pointType: 'matchmaking',
      fuel_type_ids: location.fuel_type
    })
    feature.setProperties({ ...location, type: location.type })
    feature.changed()
    return feature
  })
}
</script>

<template>
  <BaseLayerPoints
    v-if="features.length > 0"
    :features="features"
    :symbol-overrides="symbolOverrides"
  />
</template>
import { MatchmakingItem } from '~/types/MatchmakingItem'
